import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { cn } from '../cn';
import styles from './Controls.module.css';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { className, ...rest },
  ref,
) {
  return (
    <span className={cn(styles.checkboxWrap, className)}>
      <input ref={ref} type="checkbox" className={styles.nativeInput} {...rest} />
      <span className={styles.checkboxBox} aria-hidden>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 6L9 17l-5-5" />
        </svg>
      </span>
    </span>
  );
});

export interface RadioProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio({ className, ...rest }, ref) {
  return (
    <span className={cn(styles.radioWrap, className)}>
      <input ref={ref} type="radio" className={styles.nativeInput} {...rest} />
      <span className={styles.radioBox} aria-hidden />
    </span>
  );
});

export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(function Switch({ className, ...rest }, ref) {
  // Wrapping in <label> makes clicks on the visible track toggle the input,
  // which is both the right HTML pattern and keeps Playwright's default
  // click-on-checkbox working even though the native input is visually hidden.
  return (
    <label className={cn(styles.switchWrap, className)}>
      <input ref={ref} type="checkbox" role="switch" className={styles.nativeInput} {...rest} />
      <span className={styles.switchTrack} aria-hidden>
        <span className={styles.switchThumb} />
      </span>
    </label>
  );
});

export interface ControlRowProps {
  children: ReactNode;
  className?: string;
}

export function ControlRow({ children, className }: ControlRowProps) {
  return <label className={cn(styles.row, className)}>{children}</label>;
}
